import { getUserEmail } from '@/api/login'

export default {
    data() {
        return {
            loading: false,
            isRember: true,
            isVcode: false,
            loginForm: {
                username: '',
                password: '',
                time: '',
                vcode: ''
            },
            loginRules: {
                username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
                password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
                vcode: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
            },
            formdata: {
                clientId: 'iportal_client',
                state: '',
                redirectUri: this.$store.getters.objApi.LOCAL_URL + '/#/platform',
            },
            vcodeSrc: this.$store.getters.objApi.OAUTH_API + "login/vcode?date=" + (+new Date()),
            errorMsg: '',
        }
    },
    computed: {
        showCode() {
            return this.$store.getters.objApi.showCode;
        },
        recoverUri() {
            let href = window.location.href;
            let index = href.indexOf('/login');
            return href.substr(0, index) + '/recover';
        }
    },
    created() {
        if (localStorage.isRember) {
            this.loginForm.username = localStorage.isRember;
        }
    },
    methods: {
        handleLogin() {
            let time = new Date().getTime();
            this.loginForm.time = time;
            this.errorMsg = '';
            this.$refs.loginForm.validate(valid => {
                if (valid) {
                    this.loading = true;
                    if (this.isRember) {
                        localStorage.isRember = this.loginForm.username;
                    }
                    sessionStorage.setItem('firstLoginUserName', this.loginForm.username);
                    this.$store.dispatch('LoginByUser', this.loginForm).then((data) => {
                        this.loading = false;
                        this.checkHasEmail().then(isTrue => {
                            // 存在邮箱
                            if (isTrue) {
                                this.$router.push({ name: 'platform' });
                            } else {
                                // 不存在邮箱需要填写邮箱
                                this.firstLogin();
                            }
                        });
                    }).catch(error => {
                        this.errorHandling(error);
                        this.loading = false;
                    })
                } else {
                    return false
                }
            })
        },
        /**
         * 错误处理
         */
        errorHandling(error) {
            const { data, status } = error;
            this.changeImage();
            // 410 密码超期修改密码 409 首次登陆 修改密码 400 其他异常错误 403 用户名或密码错误
            if (status === 400 || status === 403) {
                this.errorMsg = data.error || data.message;
            }
            if (status === 410) {
                this.changePasswordRest(data);
            }
            if (status === 409) {
                this.firstLogin(data);
            }
        },
        changePasswordRest(data) {
            this.$message({
                message: data.message,
                type: 'warning',
                duration: 2000,
                showClose: false,
                onClose: () => {
                    this.$router.push({ name: 'PasswordReset' });
                }
            });
        },
        firstLogin(data) {
            this.$message({
                message: data.message ? data.message : '为了您的信息安全,请补全用户信息',
                type: 'warning',
                duration: 2000,
                showClose: false,
                onClose: () => {
                    this.$router.push({ name: 'change_email' });
                }
            });
        },
        async checkHasEmail() {
            const hasEmial = await getUserEmail(this.loginForm.username);
            return !!hasEmial;
        },
        changeImage() {
            this.errorMsg = '';
            this.vcodeSrc = this.$store.getters.objApi.OAUTH_API + "login/vcode?date=" + (+new Date());
        }
    }
}


// WEBPACK FOOTER //
// ./src/views/login/components/login.mixins.js